/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import styled from "styled-components";
import FormLabel from "@material-ui/core/FormLabel";
import React from "react";

const StyledFormLabel = styled(({ ...props }) => <FormLabel {...props} />)`
  ${({ theme }) => `
  `}
`;

export { StyledFormLabel };
